import axios from "axios";
import { TTP_API_URL } from "Config";
import { throwCatchedError, updateSourceToken } from "Utils";

let getMailsSourceToken;

export const getMails = ({
  token,
  limit,
  language = "fr",
  lrId,
  offset = 0,
  status = "RECEIVED",
  sourceToken
}) => {
  getMailsSourceToken = updateSourceToken(getMailsSourceToken, sourceToken);
  const filter = [{ property: "status", value: status, operator: "eq" }];

  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];
  const requestUrl = `${TTP_API_URL}/mailing/ebox-mail-list`;
  //const requestUrl = `https://api.rc2.tamtam.pro/mailing/ebox-mail-list`;

  const params = {
    access_token: token,
    //access_token: "00c3a79e5af8565656ab03719fd157571c8b1f20",
    filter: JSON.stringify(filter),
    sort: JSON.stringify(sort),
    limit,
    start: offset
  };
  if (lrId) {
    params.eboxOwnerId = lrId;
  }

  return axios
    .get(requestUrl, {
      cancelToken: getMailsSourceToken && getMailsSourceToken.token,
      params
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getSingleMail = (token, mailId) => {
  const requestUrl = `${TTP_API_URL}/mailing/ebox-mail-data`;
  //const requestUrl = `https://api.rc2.tamtam.pro/mailing/ebox-mail-data`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        //access_token: "00c3a79e5af8565656ab03719fd157571c8b1f20",
        mailId
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};

export const getGallery = ({ token, limit, offset = 0 }) => {
  const requestUrl = `${TTP_API_URL}/mailing/ebox-attachments-list`;
  //const requestUrl = `https://api2.v2.tamtam.pro/mailing/ebox-attachments-list`;

  return axios
    .get(requestUrl, {
      params: {
        access_token: token,
        //access_token: "0e004ac1b3ccc7ea847b8046220d2a1f145e557c",
        limit,
        start: offset
      }
    })
    .catch(function(thrown) {
      throwCatchedError(thrown);
    });
};



// WEBPACK FOOTER //
// ./src/api/ebox.js